// const server = {
//   // endPoint: 'http://43.205.223.1/',
//   // endPoint: "http://3.111.95.5/",
//   // endPoint: "http://3.111.95.5/", //for QA server
//   // endPoint: "https://portfolioadmin.pharsights.com/",  // Domain
//   // endPoint: "http://3.111.249.237/", //for dev server
//   endPoint: "https://portfolioqa.pharsights.com/", //for dev server
//   // endPoint:'http://127.0.0.1:8000/',
//   // endPoint:'https://oneclickfolio.com/',
//   // endPoint1: "https://oneclickfolio.com/pm_backend/",
//   // endPoint1: "http://3.111.249.237/pm_backend/", //for dev server
//   endPoint1: "https://portfolioqa.pharsights.com/pm_backend/", //for dev server
//   // endPoint1: "http://3.111.95.5/pm_backend/", //for QA server
//   // endPoint1: "https://portfolioadmin.pharsights.com/pm_backend/",
//   // endPoint1: 'http://127.0.0.1:8000/',
//   // endPoint2: 'http://65.1.95.108:8003/'
//   endPoint2: "http://43.205.223.1/",
//   // endPoint3: 'http://3.108.93.207/app/'
//   //  getendpoint:'http://43.205.223.1/pm_backend/'
//   endPoint3: "http://3.6.191.65/",
// };

const server = {
  endPoint: "https://portfoliodev.pharsights.com/", //for dev server
  // endPoint: "https://portfolioadmin.pharsights.com/",  // QA
  endPoint1: "https://portfoliodev.pharsights.com/pm_backend/", //for dev server
  // endPoint1: "https://portfolioadmin.pharsights.com/pm_backend/",  // QA
  endPoint2: "http://43.205.223.1/",
  endPoint3: "http://3.6.191.65/",
  endPoint4: "https://hiddengems.pharsights.com/api/",
};

export const AppConstants = {
  API_ENDPOINT: server.endPoint,
  API_ENDPOINT1: server.endPoint1,
  API_ENDPOINT2: server.endPoint2,
  API_ENDPOINT3: server.endPoint3,
  API_ENDPOINT4: server.endPoint4,
  CLINICAL_TRIALS_URL: "https://clinicaltrials.gov/study/",
  // REPORTS_ENDPOINT: server.endPoint3,
  API: {
    LOGIN: {
      POST_LOGIN: "login",
    },
    MOLECULE: {
      GET: "pm_backend/info/get_nda/",
    },
    LIFEMOLECULE: {
      GET: "pm_backend/info/brand_life_getnda/",
    },
    SEARCHMOLECULE: {
      POST: "pm_backend/info/esatimation_of_api/",
    },
    SEARCHMOLECULERLD: {
      POST: "pm_backend/info/esatimation_of_rld/",
    },
    SAVEMOLECULEAPI: {
      POST: "pm_backend/info/save_est_of_api/",
    },
    SAVEMOLECULERLD: {
      POST: "pm_backend/info/save_est_of_rld/",
    },
    CALCULATEMOLECULERLD: {
      POST: "pm_backend/info/cal_est_of_rld/",
    },
    CHECKCASEAPI: {
      POST: "info/CheckCASEOfAPI/",
    },
    DETAILS: {
      GET: "pm_backend/info/fetch_molecule_details/",
    },
    NDADETAILS: {
      GET: "costing/info/get_nda/",
    },
    COSTAPI: {
      GET: "costing/getAPICostValues/",
    },
    POSTAPI: {
      POST: "portfolio/costing/calculateAPICost",
    },
    VALIDATEAPI: {
      POST: "pm_backend/info/validateData/",
    },
    UPDATEMOLECULEAPI: {
      PUT: "pm_backend/info/updateDataToDb/",
    },
    CommercialAPI: {
      POST: "pm_backend/info/get-ci-data/",
    },
    UpdateCommercialAPI: {
      POST: "pm_backend/info/update-ci-data/",
    },
    GETNDA: {
      GET: "pm_backend/info/get_nda/",
    },
    SAVEPOLYMORPH: {
      POST: "pm_backend/info/save_novelpolymorph/",
    },
    UPLOADPDF: {
      POST: "pm_backend/info/expectedfileupload/",
    },
    SALESANDVOLUME: {
      POST: "pm_backend/info/get-sales-volume-data/",
    },
    UPLOADSALESEXCEL: {
      POST: "pm_backend/info/update-sales-volume-excel/",
    },
    UPDATESALESVOLUME: {
      POST: "pm_backend/info/sale-sales-volume/",
    },
    USERREGISTER: {
      POST: "app/info/register/",
    },
    LIFECYCLE: {
      LIFE_DETAILS: "pm_backend/info/BrandLifeFetchMolecueDetails/",
      LIFE_INNOVATOR_BRAND_API:
        "pm_backend/info/BrandLifeInnovatorbrandproductdetails/",
      LIFE_PATENT_INFORMATION: "pm_backend/info/brand_life_PatentInformation/",
      LIFE_REGULATORY_INFORMATION:
        "pm_backend/info/brand_life_RegulatoryInformation/",
      LIFE_CLINICAL_INFORMATION: "pm_backend/info/Brand_life_clinicaleinfo1/",
      LIFE_API_INFORMATION: "pm_backend/info/brand_life_apiinfo/",
      LIFE_FORMULATION_INFORMATION:
        "pm_backend/info/brand_life_formulationinfo/",
      LIFE_COMPITITIVE_INTELLIGENCE:
        "pm_backend/info/brand_life_compintelligence/",
      LIFE_EXECUTIVE_SUMMARY: "pm_backend/info/brand_life_execsummary/",
      LIFE_COSTING_INFORMATION:
        "pm_backend/info/brand_life_costingrelatedand_others/",
    },

    SCRAPINGUPDATE: {
      MOLECULE_LIST: "pm_backend/info/get_all_mol_list/",
      SCRAPINGFIELD_LIST: "pm_backend/info/get_all_scraping_field_list/",
      SPACIFIECONEFIELDDATA: "pm_backend/info/specific_one_field_data/",
      APPROVALFIELDDATA: "pm_backend/info/approval_field_data/",
      REJECTFIELDDATA: "pm_backend/info/Rejected_field_data/",
    },

    UPDATEMOLECULEDATA: {
      PUT: "info/update_data_based_on_aproval/",
      SECTION_ONE_PUT: "info/update_innov_details_basedon_approval_reject/",
      PATENT_UPDATED_DATA: "info/update_patentinfo_basedon_approval_reject/",
      REGULATORY_UPDATED_DATA:
        "info/update_regulatoryinfo_basedon_approval_reject/",
      CLINICAL_UPDATED_DATA:
        "info/update_clinicalinfo_basedon_approval_reject/",
      API_UPADTED_DATA: "info/update_apiinfo_basedon_approval_reject/",
      FORMULATION_UPDATED_DATA:
        "info/update_formulationinfo_basedon_approval_reject/",
      COMPETITIVE_UPDATED_DATA:
        "info/update_compintelinfo_basedon_approval_reject/",
      EXECUTIVE_UPDATED_DATA:
        "info/update_execsummary_basedon_approval_reject/",
      COSTING_UPDATED_DATA:
        "info/update_costingrelated_basedon_approval_reject/",
    },

    UPLOADEXCEL: {
      POST: "pm_backend/info/rld_prices_file_upload/",
      UPLOAD_EXCEL: "info/upload/",
      UPLOAD_SALES_VOLUME: "info/upload_excel/-",
    },
    DOWNLOADFILE: {
      POST: "info/file_service/",
      DOWLOAD_SELECTED_POST: "info/downloadselected/",
    },
    PARA: {
      PUT: "pm_backend/info/update_filing",
    },

    POSTAPICOST: {
      POST: "costing/info/data_display/",
      // POST: "costing/info/data_display_new/",
      EDIT_APICOST: "costing/info/edit_different_costing_data/",
    },
    // API for displaying Regulatory_Cost
    REGULATORYCOST: {
      GET: "costing/info/regulatory_cost/",
      // GET: "costing/info/regulatory_cost_new/",
    },
    // API for displaying BE_STUDY_COST
    BESTUDYCOST: {
      POST: "costing/info/bestudy_cost/",
      // POST: "costing/info/bestudy_cost_new/",
    },
    // API for displaying RLD_STUDY_COST
    RLDSTUDYCOST: {
      POST: "costing/info/rldstudy_cost/",
      // POST: "costing/info/rldstudy_cost_new/",
    },
    // API for displaying DF_COMPLEXITY_STUDY_COST
    ANALITICALCOST: {
      POST: "costing/info/df_complexity_cost/",
      // POST: "costing/info/df_complexity_cost_new/",
    },
    // API for displaying IP_STUDY_COST
    IPCOST: {
      POST: "costing/info/ip_costing/",
      // POST: "costing/info/ip_costing_new/",
    },
    // API for displaying DATA_DIRECTORY
    DATADIRECTORY: {
      POST: "pm_backend/info/data_directory/",
    },
    Timelines: {
      POST: "costing/info/timelines_costing/",
    },
    CUMULATIVE_INVESTMENT: {
      POST: "costing/info/cumulative_frontend_investmnt/",
    },
    BUSINESSCASE: {
      POST: "costing/info/bussiness_care_data/",
      USER_POST: "costing/info/user_business_case/",
      FUTURE_VOLUME_GROWTH: "get_inital_damp",
      MARKET_SHARE: "get_market_share",
      RLD_PRICE_INCREASE: "get_rld_price_increase",
      PRICE_EROSION: "get_price_erosion",
      BUSINESS_CASE: "display_bussiness_case_data",
      CUMULATIVIE_REVENUE: "costing/info/cumulative_frontend_revenue/",
      BUSINESS_CASE_NA: "costing/info/business_if_na/",
      UPDATE_BUSINESS_CASE: "costing/info/updated_business_case/",
      UPDATE_USER_BUSINESS_CASE: "costing/info/user_update_business_case/",
      REFRESH_DATA: "costing/info/refresh_business_case/",
      BC_STRENGTH_UNIT_PRICE: "BusinessCaseIQVIA/bc-strength-unitprice",
      LOCK_BUSINESSCASE: "costing/info/lock_businesscase/",
      BUSINESS_CASE_STATUS: "costing/info/businesscase_status/"
    },
    SENDEMAIL: {
      POST: "info/send_email_for_approval/",
      INNOVATOR_BRAND_EDIT_API: "info/innovatorbrandproductdetails/",
      PATENT_INFO: "info/patent_info/",
      REGULATORY_INFO: "info/regulatory_info/",
      CLINICAL_INFO: "info/clinical_info/",
      API_INFO: "info/api_info/",
      FORMULATION_INFO: "info/formulation_info/",
      COMPETITIVE_INFO: "info/comp_intelligence/",
      EXECUTIVE_INFO: "info/exec_summary/",
      COSTING_RELATED_INFO: "info/costing_relatedand_others/",
    },
    GETEDITEDDATA: {
      GET: "info/getediteddata/",
      GET_SECTION_ONE_DATA: "info/get_edited_innov_details/",
      PATENT_INFO_EDITED: "info/get_edited_patent_info/",
      REGULATORY_INFO: "info/get_edited_regulatory_info/",
      CLINICAL_INFO: "info/get_edited_clinical_info/",
      API_INFO: "info/get_edited_api_info/",
      FORMULATION_INFO: "info/get_edited_formulation_info/",
      COMPETITIVE_INFO: "info/get_edited_compintel_info/",
      EXECUTIVE_INFO: "info/get_edited_execsummary_info/",
      COSTING_RELATED_INFO: "info/get_edited_costingrelated_info/",
      BRAND_DETAILS_DATA: "SalesOverview/GetBrandDetailsBy_BrandName_NDA_Dosage/"
    },
    SECTION_API: {
      INNOVATOR_BRAND_API: "info/innovatorbrandproductdetails/",
      PATENT_INFORMATION: "info/patent_info/",
      LITIGATION_INFORMATION: "info/litigation_data_ip/",
      OTHER_LITIGATION_INFORMATION: "info/get_other_litigations_data/",
      REGULATORY_INFORMATION: "info/regulatory_info/",
      CLINICAL_INFORMATION: "info/clinical_info/",
      API_INFORMATION: "info/api_info/",
      FORMULATION_INFORMATION: "info/formulation_info/",
      COMPITITIVE_INTELLIGENCE: "info/comp_intelligence/",
      EXECUTIVE_SUMMARY: "info/exec_summary/",
      COSTING_INFORMATION: "info/costing_relatedand_others/",
      GET_USPTO_TOKEN: '/info/get-uspto-token/',
      GET_USPTO_PATENT_URL: 'info/get-uspto-patent-url/',
      TOGGLE_LCM_EVIDENCE: "info/toggle_lcm_evidence/",
    },
    MANUAL_ENTRY_API: {
      MANUAL_EDIT_DATA: "info/manualentry/",
    },
    SALES_AND_VOLUME_APIS: {
      GENERIC_NAME_DROPDOWN: "info/generic_name_dropdown/",
      BRAND_NAME_DROPDOWN: "info/brand_drop_down/",
      ROA_DROPDOWN: "info/roa_drop_down/",
      DOSAGE_DROPDOWN: "info/dosage_drop_down/",
      NATURE_DROPDOWN: "info/nature_drop_down/",
      STRENGTH_DROPDOWN: "info/stren_drop_down/",
      // OTHER_DROPDOWNS: 'info/Other_dropdowns/',
      SALES_VOLUME_DATA: "info/get_sales_volume_data/",
      UPDATED_SALES_DATA: "info/update_sales_volume_data/",
      NDA_DROPDOWN: "info/nda_drop_down/",
      UPDATE_SALES_VOLUME: "info/load_sales_volume/",
    },
    REPORTS: {
      DAILY_REPORT: "info/old_back_tab/",
      WEEKLY_REPORT: "info/old_weekly_back_tab/",
      QUIRIES_REPORT: "info/old_quries_back_tab/",
      DOWNLOAD_DAILY_REPORT: "info/daily_backend_down/",
      DOWNLOAD_MONTHLY_REPORT: "info/down_monthly_excel/",
      QUIRIES_DOWNLOAD: "info/quries_monthly_excel/",
    },
    PER_DAY_DOSAGE: {
      GENERIC_NAMES: "info/dosage_active_drop/",
      BRAND_NAMES: "info/dosage_brand_drop/",
      NDA: "info/dosage_nda_drop/",
      SUBMIT_PDD: "info/dosage_perday/",
    },
    LOG_MANAGEMENT: {
      LOG_DATA: "pm_backend/info/all_log_data/",
      DS_ANDA_DR: "pm_backend/info/ds_anda_ar/",
      LMS_DS_TIME: "pm_backend/info/lms_ds_time/",
      UNIQUE_ROA: "pm_backend/info/unique_roa/",
      LMS_NOTES: "pm_backend/info/daily_script_notes/",
      GET_SALE_VOL_COM: "pm_backend/info/get_nda_sale_vol_com/",
      GET_LCM_SCREENSHOTS: "pm_backend/info/get_lcm_screenshots/",
      LMS_SHORTAGE_STATUS: 'pm_backend/info/lms_shortage_status/',
    },
    ALL_BUSINESSCASE_DATA: {
      BUSINESSCASE_LOG_DATA: "pm_backend/info/all_businesscase_data/"
    },
    IRR_DATA: {
      IRR_LOG_DATA: "pm_backend/info/all_businesscase_irr_data/"
    },
    IRR_NPV_DATA: {
      IRR_NPV_LOG_DATA: "pm_backend/info/all_businesscase_irr_npv_data/"
    },
    ALL_SALES_VOLUME: {
      SALES_VOLUME_ZERO_DATA: "pm_backend/info/all_sale_volumn_zero_data/"
    },
    IRR_GREATER_HUNDRED: {
      IRR_GREATER_HUNDRED_DATA: "pm_backend/info/all_morethan_hundred_irr_data/"
    },
    IRR_GREATER_TWENTYFIVE: {
      IRR_GREATER_TWENTYFIVE_DATA: "pm_backend/info/all_genericized_morethan_twentyfive_irr_data/"
    },
    ALL_AMFD_DATA: {
      ALL_AMFD_NEW_DATA: "pm_backend/info/all_market_formulation_date/"
    },
    ALL_COSTING_DATA: {
      COSTING_NEW_DATA: "pm_backend/info/all_costing_morethan_ten_data/"
    },
    ALL_COSTING_CHECKER_DATA: {
      COSTING_CHECKER_LOG_DATA: "pm_backend/info/all_costing_comp_checker_data/"
    },
    UPLOAD_TO_LIVE_DB: {
      UPLOAD_TO_LIVE: "info/upload_to_live_db/"
    },
    USER_REGISTRATION_FORM: {
      USER_REGISTRATION: "info/user-registration/",
      USER_DATA_UPDATE: "pm_backend/info/user_data_update/",
      COMPANY_DATA_UPDATE: "pm_backend/info/get_all_companies/",
      CHANGE_USER_STATUS: "pm_backend/info/change_user_status/",
      CHANGE_COMPANY_STATUS: "pm_backend/info/update_company_status/",
      UPDATE_COMPANY_EXPIRY_DATE: "pm_backend/info/update_company_expiry/",
      GET_PRODUCTS: "pm_backend/info/user-registration/"
    },
    PADUFA: {
      PDUFA_CALENDAR: "pm_backend/info/pdufa_calendar/",
      PDUFA_INFORMATION: "pm_backend/info/pdufa_information/",
      PDUFA_INFORMATION_DATA: "pm_backend/info/map_nda_details/",
      PDUFA_ANALOG_CALCULATE: "pm_backend/info/ps_calculation/",
      PDUFA_REFRESH_DATA: "pm_backend/info/ps_information/"

    },
    REQUEST_TRAINING_DATA: {
      REQUEST_DATA: "pm_backend/info/traning_data/"
    },
    CLOSE_REQUEST: {
      CLOSE_REQUEST_DATA: "info/traning_data/"
    },
    PRODUCT_DASHBOARD: {
      PRODUCT_DASHBOARD_DATA: "pm_backend/info/all_products/",
      REMOVE_PRODUCT: "pm_backend/info/remove_products_emails/",
      REMOVE_PRODUCT_DATA: "pm_backend/info/remove_products/"
    },
    ALL_RLD_DATA: {
      ALL_RLD_ZERO_OR_NOT: "pm_backend/info/all_zero_rld_data/"
    },
    EXCEL_MANAGER: {
      ALL_FILE_LIST: "pm_backend/info/excel_db_filelist/",
      FILE_DATA: "pm_backend/info/excel_db_filedata/",
      FILE_UPDATE_USAGE: "pm_backend/info/update_usage_of_file/",
      FILE_UPDATE_VALUE: "pm_backend/info/update_value_of_file/",
      DOWNLOAD_EXCEL_DB: "pm_backend/info/convert_to_excel/",
      RENAME_EXCEL: "pm_backend/info/rename_file/",
      UPLOAD_EXCEL_FILE: "pm_backend/info/upload_costing_excel/",
    },
    EMAIL_LITIGATION: {
      LITIGATION_DATA: "pm_backend/info/extract_litigation_data/",
      DELETE_LITIGATION: "pm_backend/info/delete_litigation/",
      LITIGATION_AR: "pm_backend/info/approve_reject_litigation/",
      HOLD_LITIGATION: "pm_backend/info/hold_litigation/",
      ADD_LITIGATION: "pm_backend/info/manual_litigation_entry/",
      UPDATE_LITIGATION: "pm_backend/info/update_litigation_data/",
      EVENTS_GET_ALL: "pm_backend/info/get_all_events/",
      EVENTS_ADD_NEW: "pm_backend/info/add_new_events/",
      EVENTS_UPDATE_NAME: "pm_backend/info/update_event_name/",
      CASE_EVENTS_ADD: "pm_backend/info/add_case_events/",
      CASE_EVENTS_VIEW: "pm_backend/info/view_case_events/",
      LITIGATION_ALL_EVENTS: "pm_backend/info/litigation_all_events/",
      UNDO_DELETED_RECORD: "pm_backend/info/undo_deleted_record/",
      CASE_EVENTS_DELETE: "pm_backend/info/delete_case_event/",
      ADD_APPEAL_CASE: "pm_backend/info/add_appeal_cases/",
      UPDATE_APPEAL_CASE: "pm_backend/info/update_appeal_cases/",
      DELETE_APPEAL_CASE: "pm_backend/info/delete_appeal_cases/",
      UNDO_APPEAL_CASE: "pm_backend/info/undo_appeal_cases/",
      ADD_APPEAL_EVENT: "pm_backend/info/add_appeal_event/",
      GET_ALL_APPEAL_EVENTS: "pm_backend/info/get_all_appeal_events/",
      RENAME_APPEAL_EVENT: "pm_backend/info/rename_appeal_event/",
      APPEAL_CASE_EVENTS_ADD: "pm_backend/info/add_appeal_case_event/",
      APPEAL_CASE_EVENTS_VIEW: "pm_backend/info/view_appeal_case_events/",
      APPEAL_CASE_EVENTS_DELETE: "pm_backend/info/delete_appeal_case_event/",
      APPEAL_EVENTS_DASHBOARD: "pm_backend/info/appeal_events_dashboard/",
      OTHER_EVENTS_DASHBOARD: "pm_backend/info/other_events_dashboard/",
      APPEAL_APPROVE_REJECT: "pm_backend/info/appeal_approve_reject/",
    },
    LITIGATION_COMPLAINTS: {
      COMPLAINTS_DATA: "pm_backend/info/extract_litigation_complaints/",
      VIEW_ALL_COMPLAINTS_DATA: "pm_backend/info/raw_litigation_data/",
      RERUN_LITIGATION_LOGIC: "pm_backend/info/rerun_litigation_logic/",
      GET_MOST_SEARCHED_PRODUCTS: "pm_backend/info/get_most_searched_products/",
      GET_USER_COMPANY: "pm_backend/info/get_mail_and_company/",
      GET_COMPANY_MASTER: "pm_backend/info/update_company_master/"

    },
    LMS_DS_MANUAL_ENTRY: {
      GET_UNIQUE_WHICHFIELD: "pm_backend/info/get-unique-whichfield/",
      ADD_LMS_DS_ENTRY: "pm_backend/info/add_lms_ds_entry/", // <-- change if your backend has different endpoint
    },
    NEW_COSTING: {
      API_COST: "costing/info/data_display/",
      // API_COST: "costing/info/data_display_new/",
      BE_STUDY_COST: "costing/info/bestudy_cost/",
      // BE_STUDY_COST: "costing/info/bestudy_cost_new/",
      RLD_COST: "costing/info/rldstudy_cost/",
      // RLD_COST: "costing/info/rldstudy_cost_new/",
      REGULATORY_COST: "costing/info/regulatory_cost/",
      // REGULATORY_COST: "costing/info/regulatory_cost_new/",
      COMPLEXITY_COST: "costing/info/df_complexity_cost/",
      // COMPLEXITY_COST: "costing/info/df_complexity_cost_new/",
      PACKAGE_COST: "costing/info/package_costing/",
      IP_COST: "costing/info/ip_costing/",
    },
    REGISTER_USER: {
      USER_ACSESS: "info/user_access/",
      GET_USERS: "pm_backend/info/all_users_access/",
      DELETE_USER: "info/delete_registered_user/",
      UPDATE_USER: "info/user_access_modify/"
    },
    RESET_ADMIN_USER_PASSWORD: {
      RESET_PASSWORD: "info/forgot_reset_password/",
    },
    SUBSCRIBER_EMAIL: {
      SUBSCRIBER_MAIL: "pm_backend/info/subscriber_email/",
      VIEW_TEMPLATE: "pm_backend/info/render_email_template/"
    },
    SUBSCRIBER_EMAIL_USERS: {
      SUBSCRIBER_MAIL_USER: "pm_backend/info/new_user_email_subscriber/",
    },
    SECTION_WISE_EMAIL: {
      SEND_EMAIL: "/pm_backend/info/send-email/"
    },
    CUSTOMER_LOGS: {
      CUSTOMER_LOGS_DATA: "pm_backend/info/all_customer_logs/",
    },
    ALL_USERS_MAIL_ID: {
      USERS_MAIL_ID: "pm_backend/info/all_users_mailid/",
      FIELD_REVIEW: "pm_backend/info/all_field_reviews/",
      VERIFY_FIELD: "pm_backend/info/verify_field/",
      USER_LIST: "costing/info/user_live_list/",
    },
    ALL_PRODUCT_STATUS: {
      PRODUCT_STATUS: "pm_backend/info/get_product_status/",
      UPDATE_PRODUCT_STATUS: "pm_backend/info/update_product_status/",
      UPDATE_PRODUCT_COMMENT: "pm_backend/info/update_product_comment/",
    },
    PATENTS_EXPIRATION: {
      GET_PATENT_EXPIRATION: "pm_backend/info/get_patents_expiration/"
    },
    EXCEL_DUMP: {
      GET_ALL_KEYS: "pm_backend/info/get_all_keys/",
      GET_EXCEL_DUMP: "pm_backend/info/generate_excel_dump/"
    },
    GET_ALL_BE_GUIDANCE: {
      BE_GUIDANCE: "pm_backend/info/get_all_be_guidance/"
    },
    LIVE_UPDATES: {
      NDA_APPROVALS: "pm_backend/info/ndaapprovals/",
      ANDA_APPROVALS: "pm_backend/info/andadataapprovals/",
      NEW_DOSAGE_FORM: "pm_backend/info/newdosageform/",
      TENTATIVE_ANDA_APPROVAL: "pm_backend/info/tentativeandaapproval/",
      LABELLING: "pm_backend/info/labelling/",
      NEW_APPROVED_STRENGTH: "pm_backend/info/newapprovedstrength/",
      DELISTED_PATENTS_DATABASE: "pm_backend/info/delistedpatentsdatabase/",
      LISTED_PATENTS_DATABASE: "pm_backend/info/newlistedpatentsdatabase/",
      UPDATE_BE_GUIDANCE: "pm_backend/info/updatedbeguidance/",
      UPDATE_IS_IN_LIVE: "pm_backend/info/update_is_in_live/",
      NEW_APPROVED_INDICATION: "pm_backend/info/newapprovedindications/"
    },
    PUSH_TO_LIVE: {
      GET_OPTIONS: "pm_backend/info/get-options/",
      UPLOAD_EXCEL: "pm_backend/info/upload-excel-ptl/",
      GET_RECORDS: "pm_backend/info/get-ptl-logs/"
    },
    PTE_EVENTS: {
      GET_EVENTS: "pm_backend/info/get_pte_events",
      GET_PTE_PDF: "pm_backend/info/get_pte_pdf",
    },
    UPLOAD_SHORTAGE_FILE: {
      GET_RECORDS: "pm_backend/info/get_shortage_excel/",
      UPLOAD_FILE: "pm_backend/info/get_shortage_excel/",
      PROCESS_NDA_MAPPING: "pm_backend/info/process_nda_mapping/",
    },
    SHORTAGE: {
      SHORTAGE_OVERVIEW: "pm_backend/info/shortage_overview/",
      SHORTAGE_ANALYTICS: "pm_backend/info/shortage_analytics/",
      SHORTAGE_CHANGELOG: "pm_backend/info/shortage_change_logs/",
      SHORTAGE_RECOVERY: "pm_backend/info/shortage_recovery/",
      SHORTAGE_EXPLORER: "pm_backend/info/shortage_data/",
      SHORTAGE_COMMENTS: "pm_backend/info/shortage_comments/",
      RERUN_NDC: "pm_backend/info/rerun_ndc/",
      SHORTAGE_RECORDS: "pm_backend/info/shortage_records/"
    },
  },
};